<!-- Header para Mobile -->
<div class="bg-white xl:hidden">
  <div class="container mx-auto px-2 md:px-0">
    <div class="flex flex-wrap items-center gap-2">
      <!-- Menú hamburguesa -->
      <button
        (click)="onToggleSidebar()"
        class="flex gap-2 items-center p-1 text-gray-700 transition-colors"
      >
        <img
          src="/allas-icons/hamburger_icon.svg"
          alt="Menú"
          class="h-4"
          width="22"
          height="16"
          loading="eager"
        />
        <span class="text-sm font-light fs-condensed">Menú</span>
      </button>

      <!-- Sección central - Logo centrado -->
      <a
        class="flex flex-col gap-1 flex-auto items-center justify-center"
        href="/"
      >
        <img
          src="/logos/default.webp"
          alt="ALLAS REPUESTOS"
          class="w-max h-10 aspect-[264/68]"
        />
      </a>

      <!-- Mi Cuenta -->
      <allas-user-menu></allas-user-menu>

      <!-- Mi Carrito -->
      <allas-cart-mini></allas-cart-mini>
    </div>
    <allas-search-bar divStyleClass="mt-2"></allas-search-bar>

    <div class="flex gap-2 border-t border-b border-gray-200 mt-2 py-2">
      <allas-garage-dropdown class="w-full"></allas-garage-dropdown>
    </div>
  </div>
</div>
